import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { LuMail } from "react-icons/lu";

export default function Footer() {
  return (
    <footer
      id="footer"
      className="bg-white text-center py-12 px-4 border-t border-gray-200"
    >
      <div className="max-w-3xl mx-auto">
        {/* Logo + Brand */}
        <div className="flex justify-center items-center gap-2 mb-4">
          <img
            src="/logo.png"
            alt="Logo Logo"
            className="w-20 h-20 rounded-full"
          />
        </div>

        {/* <a href="tel:+917303837337">
          <p className="text-gray-600 text-xs max-w-xl mx-auto mb-6">
            <strong>Contact Number: </strong>+917303837337
          </p>
        </a> */}

        {/* Social Icons */}
        <div className="flex justify-center gap-4 mb-6">
          <a href="https://wa.me/+918755060291">
            <div className="bg-white shadow-md rounded-full p-3 text-black hover:text-[#3c2b61] transition">
              <FaWhatsapp />
            </div>
          </a>
          {/* <a href="https://www.instagram.com/rankmybook?igsh=b2NmcTJnbnI3Zndw">
            <div className="bg-white shadow-md rounded-full p-3 text-black hover:text-[#3c2b61] transition">
              <FaInstagram />
            </div>
          </a> */}
          <a href="mailto:rankmythisbook0@gmail.com">
            <div className="bg-white shadow-md rounded-full p-3 text-black hover:text-[#3c2b61] transition">
              <LuMail />
            </div>
          </a>
        </div>

        {/* Copyright */}
        <hr className="border-gray-200 mb-4" />
        <p className="text-sm text-gray-500">
          Copyright © 2018. All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
